// @ts-nocheck
import React, { useState } from "react";
import {
    Box,
    TextField,
    Typography,
    Divider,
    Button,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    FormLabel,
    IconButton,
    InputAdornment,
    Chip,
    Alert,
} from "@mui/material";
import { Save } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from "@mui/icons-material/Remove";
import Joi from "joi";
import axios from "axios";
import { RUTA_API_ALIAS } from "../Contantes/Constantes";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import { useAlias } from "./State/AliasContext";
import { useBody } from "../Body/state/BodyContext";
import SelectAreaArbol from "../Areas/Componentes/SelectAreaArbol";

const initialState = {
    nombre: "",
    descripcion: "",
    mail: "",
    visibilidadLibreta: "1",
    destinatarios: [],
    area: null,
};

const validationSchema = Joi.object({
    mail: Joi.string()
        .email({ minDomainSegments: 2, tlds: { allow: ["com", "net", "ar"] } })
        .required(),
    nombre: Joi.string().min(3).max(70).required().invalid("/"),
    descripcion: Joi.string().min(10).max(100).required(),
    visibilidadLibreta: Joi.number().required(),
    destinatarios: Joi.array().items(
        Joi.string().email({ minDomainSegments: 2, tlds: { allow: ["com", "net", "ar"] } }).required()
    ),
    area: Joi.string().allow("").required(),
});

const mapAlias = (alias) => ({
    area: alias?.area?.id,
    descripcion: alias.descripcion,
    destinatarios: alias.destinatarios,
    mail: alias.mail,
    nombre: alias.nombre,
    visibilidadLibreta: String(alias.visibilidadLibreta),
});

export const AliasForm = ({ alias, method, onClose }) => {
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { load, setLoad, patron, fetchAlias } = useAlias();
    const { setSuccess, setMessage } = useBody();

    const [values, setValues] = useState(alias !== null ? mapAlias(alias) : initialState);
    const mailOriginal = alias?.mail ?? null;
    const [destinatario, setDestinatario] = useState("");
    const [alertDestinatario, setAlertDestinatario] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (field) => (e) => setValues((prev) => ({ ...prev, [field]: e.target.value }));

    function validateForm() {
        if (values.mail.toLowerCase().startsWith("no-reply")) return "nombreNoReply";
        const { error } = validationSchema.validate(values);
        if (error) return error.details[0].path[0];
    }

    const mensajeError = (fallo) => {
        const mensajes = {
            mail: "El email del alias es inválido. Debe tener el formato nombre@dominio.com / .net / .ar",
            nombre: "El nombre debe tener entre 3 y 70 caracteres y no puede contener '/'",
            descripcion: "La descripción debe tener entre 10 y 100 caracteres",
            destinatarios: "Uno o más destinatarios tienen un formato de email inválido",
            area: "Debe seleccionar el área a la que pertenece el alias",
            nombreNoReply: "El email del alias no puede comenzar con 'no-reply'",
        };
        setMessage(mensajes[fallo] ?? "Hay un error en el formulario, revisá los campos");
    };

    function handleAddDestinatario() {
        if (!destinatario) {
            setAlertDestinatario({ status: "error", message: "El destinatario no puede ser vacío" });
            return;
        }
        setValues((prev) => ({ ...prev, destinatarios: [...prev.destinatarios, destinatario] }));
        setDestinatario("");
        setAlertDestinatario(null);
    }

    function handleRemoveDestinatario(item) {
        setValues((prev) => ({ ...prev, destinatarios: prev.destinatarios.filter((d) => d !== item) }));
    }

    const handleSubmit = async () => {
        if (destinatario !== "") {
            setMessage("Debe confirmar el destinatario antes de guardar");
            return;
        }
        const error = validateForm();
        if (error) { mensajeError(error); return; }

        setLoading(true);
        setLoad(true);
        try {
            const payload = { ...values, visibilidadLibreta: parseInt(values.visibilidadLibreta) };
            if (method === "POST") {
                await axiosInstance.post(RUTA_API_ALIAS, payload);
                setSuccess("Nuevo alias creado.");
            } else {
                await axiosInstance.put(RUTA_API_ALIAS, { ...payload, mailOriginal });
                setSuccess("Alias actualizado.");
            }
            fetchAlias(patron);
            onClose();
        } catch (error) {
            const msg = error.response?.data?.error
                ?? (method === "POST" ? "No se pudo crear el alias." : "No se pudo editar el alias.");
            setMessage(msg);
        } finally {
            setLoad(false);
            setLoading(false);
        }
    };

    return (
        <Box component="form" onSubmit={(e) => e.preventDefault()} mt={2}>
            <Box display="flex" gap={2} mb={2}>
                <TextField
                    label="Email Alias"
                    value={values.mail}
                    onChange={handleChange("mail")}
                    onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}
                    disabled={load}
                    variant="standard"
                    fullWidth
                />
                <TextField
                    label="Nombre Alias"
                    value={values.nombre}
                    onChange={handleChange("nombre")}
                    onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}
                    disabled={load}
                    variant="standard"
                    fullWidth
                />
            </Box>

            <TextField
                label="Descripción"
                value={values.descripcion}
                onChange={handleChange("descripcion")}
                onKeyPress={(e) => e.key === "Enter" && e.preventDefault()}
                disabled={load}
                multiline
                rows={2}
                variant="outlined"
                fullWidth
                sx={{ mb: 2 }}
            />

            <SelectAreaArbol
                area={values.area}
                setArea={(id) => setValues((prev) => ({ ...prev, area: id }))}
                disabled={load}
            />

            <Divider sx={{ my: 3 }}>
                <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
            </Divider>

            {alertDestinatario && (
                <Alert severity="error" sx={{ mb: 1 }} onClose={() => setAlertDestinatario(null)}>
                    {alertDestinatario.message}
                </Alert>
            )}

            <TextField
                label="Agregar destinatario"
                value={destinatario}
                onChange={(e) => setDestinatario(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleAddDestinatario()}
                disabled={load}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleAddDestinatario} disabled={load}>
                                <AddIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />

            {values.destinatarios.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1 }}>
                    {values.destinatarios.map((d) => (
                        <Chip
                            key={d}
                            label={d}
                            variant="outlined"
                            onDelete={() => handleRemoveDestinatario(d)}
                            deleteIcon={<RemoveIcon />}
                        />
                    ))}
                </Box>
            )}

            <Divider sx={{ my: 3 }}>
                <Typography variant="caption" color="text.secondary">Visibilidad Libreta</Typography>
            </Divider>

            <FormControl component="fieldset" disabled={load}>
                <RadioGroup
                    row
                    name="visibilidadLibreta"
                    value={values.visibilidadLibreta}
                    onChange={handleChange("visibilidadLibreta")}
                >
                    <FormControlLabel value="1" control={<Radio />} label="Visible" />
                    <FormControlLabel value="0" control={<Radio />} label="No Visible" />
                </RadioGroup>
            </FormControl>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}>
                <Button
                    sx={{ textTransform: "none" }}
                    variant="outlined"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancelar
                </Button>
                <Button
                    sx={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    startIcon={loading ? null : <Save />}
                    disabled={loading}
                    onClick={handleSubmit}
                    type="button"
                >
                    {loading ? (method === "POST" ? "Agregando..." : "Actualizando...") : method === "POST" ? "Agregar Alias" : "Actualizar"}
                </Button>
            </Box>
        </Box>
    );
};
